<template>
  <div class="col-md-4 !tw-mx-auto login-wrapper reset__main">
    <div class="login-logo">
      <img
        :src="logo"
        alt="logo"
      >
    </div>

    <form
      :class="{ 'loading':loading, 'error':error }"
      @submit.prevent
    >
      <Card class="card-login ">
        <div class="loading__block">
          <i class="fa fa-spinner fa-3x fa-fw login__spinner" />
        </div>
        <section class="inputs">
          <h3>{{ $t('forms.resetPassword') }}</h3>
          <div class="row mb-18">
            <div class="col-md-9 col-12">
              {{ $t('forms.resetText') }}
            </div>
          </div>
          <UiInput
            v-model="model.new_password"
            v-model:error="errors.new_password"
            :label="$t('forms.newPasswordLabel')"
            type="password"
            placeholder="********"
            :disabled="loading"
            class="mb-4"
            autofocus
            wrapper-type="registration"
            error-clear-on-change
            @input="checkValid"
          />
          <UiInput
            v-model="repeat_password"
            v-model:error="errors.repeat_password"
            :label="$t('forms.repeat_password')"
            type="password"
            placeholder="********"
            :disabled="loading"
            class="mb-4 mt-22"
            autofocus
            wrapper-type="registration"
            error-clear-on-change
            @input="checkRepeatPassword"
          />
          <div class="btn-box !tw-flex !tw-justify-between mt-22">
            <button
              class="btn btn-block btn-outline-primary big btn-md"
              @click="$router.push('/login')"
            >
              &lt; {{ $t('forms.btn.back') }}
            </button>
            <button
              :disabled="loading || !valid_password || repeat_password !== model.new_password"
              class="btn btn-block btn-primary big btn-md"
              @click="resetPassword"
            >
              {{ $t('forms.btn.submit') }} &gt;
            </button>
          </div>
        </section>
      </Card>
    </form>
  </div>
</template>

<script>
import { required, minLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
  data() {
    return {
      passwordShown: false,
      emailValidation: false,
      passwordValidation: false,
      repeat_password: '',
      loading: false,
      valid_password: false,
      errors: {
        new_password: null,
        repeat_password: null,
      },
      model: {
        email: this.$route.params.email,
        token: this.$route.params.id,
        new_password: '',
      },
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      model: {
        new_password: {
          required,
          minLength: minLength(8),
        },
      },
    };
  },
  computed: {
    error() {
      return this.$store.state.errors.request >= 400;
    },
    logo() {
      return this.$config.layout.logoFull;
    },
  },
  methods: {
    async checkValid() {
      this.valid_password = await this.v$.$validate();
      if(!this.valid_password) {this.errors.new_password = this.$t('forms.validation.password');}
    },
    async checkRepeatPassword() {
      if(this.repeat_password !== this.model.new_password) {this.errors.repeat_password = this.$t('forms.passwordsNotMatch');}
    },
    resetPassword() {
      this.loading = true;
      this.$request
        .post('auth/reset-password', this.model)
        .then(() => {
          this.$router.push('/login');
        })
        .catch((err) => {
          if (err.response.data.errors && err.response.data.errors.token) {
            this.$alert.error(err.response.data.errors.token[0].message);
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/resetpassword';
</style>
